import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getOrderExpeditionPackageDetailFetchSuccess,
    getOrderExpeditionPackageDetailFetchFailure,
    updateOrderExpeditionPackageDetailFetchSuccess,
    updateOrderExpeditionPackageDetailFetchFailure,
    deleteOrderExpeditionPackageDetailFetchSuccess,
    deleteOrderExpeditionPackageDetailFetchFailure,
} from './reducer';
import { OrderExpeditionPackageDetailResType } from 'src/types/orderExpeditionPackageDetail';
import { OrderExpeditionPackageType } from 'src/types/orderExpeditionPackage';
import translate from '@translate';

const getOrderExpeditionPackageDetailFetchRequest = async (idOrderExpeditionPackage: string) => {
    const res = await api('get', `api/secure/order-expedition-packages/${idOrderExpeditionPackage}`);
    return res.data;
};

function* getOrderExpeditionPackageDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: OrderExpeditionPackageDetailResType = yield call((): any =>
            getOrderExpeditionPackageDetailFetchRequest(action.payload)
        );
        yield put(getOrderExpeditionPackageDetailFetchSuccess(response));
    } catch (error) {
        yield put(getOrderExpeditionPackageDetailFetchFailure({ error }));
    }
}

export function* getOrderExpeditionPackageDetailFetchWatch() {
    yield takeEvery(
        'orderExpeditionPackageDetail/getOrderExpeditionPackageDetailFetch',
        getOrderExpeditionPackageDetailFetch
    );
}

const updateOrderExpeditionPackageDetailFetchRequest = async (params: {
    idOrderExpeditionPackage: string;
    data: OrderExpeditionPackageType;
}) => {
    const res = await api(
        'put',
        `api/secure/order-expedition-packages/${params.idOrderExpeditionPackage}`,
        params.data
    );
    return res.data;
};

function* updateOrderExpeditionPackageDetailFetch(action: {
    type: string;
    payload: { idOrderExpeditionPackage: string; data: OrderExpeditionPackageType };
}) {
    try {
        const response: OrderExpeditionPackageDetailResType = yield call((): any =>
            updateOrderExpeditionPackageDetailFetchRequest(action.payload)
        );
        yield put(
            updateOrderExpeditionPackageDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('orderExpeditionPackages.message.orderExpeditionPackageUpdated') },
            })
        );
    } catch (error) {
        yield put(updateOrderExpeditionPackageDetailFetchFailure({ error }));
    }
}

export function* updateOrderExpeditionPackageDetailFetchWatch() {
    yield takeEvery(
        'orderExpeditionPackageDetail/updateOrderExpeditionPackageDetailFetch',
        updateOrderExpeditionPackageDetailFetch
    );
}

const deleteOrderExpeditionPackageDetailFetchRequest = async (idOrderExpeditionPackage: string) => {
    const res = await api('delete', `api/secure/order-expedition-packages/${idOrderExpeditionPackage}`);
    return res.data;
};

function* deleteOrderExpeditionPackageDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: OrderExpeditionPackageDetailResType = yield call((): any =>
            deleteOrderExpeditionPackageDetailFetchRequest(action.payload)
        );
        yield put(
            deleteOrderExpeditionPackageDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('orderExpeditionPackages.message.orderExpeditionPackageDeleted') },
            })
        );
    } catch (error) {
        yield put(deleteOrderExpeditionPackageDetailFetchFailure({ error }));
    }
}

export function* deleteOrderExpeditionPackageDetailFetchWatch() {
    yield takeEvery(
        'orderExpeditionPackageDetail/deleteOrderExpeditionPackageDetailFetch',
        deleteOrderExpeditionPackageDetailFetch
    );
}
